import { getLaborScopeTotalParts } from 'lib/selectors/getScopeTotalParts';
import { getRejectedParts } from 'lib/selectors/getRejectedParts';
import { createSelector } from 'reselect';
import { getNetSetupParts } from './getSetupParts';
import { getNetShiftSetupParts } from './getShiftSetupParts';
import { getSetupModeSpansShift } from './getSetupModeSpansShift';
import { getTotalUserAddedManualPartCounts } from './getTotalUserAddedManualPartCounts';

const getSetupPartsDisplay = createSelector(
  [
    getNetSetupParts,
    getRejectedParts,
    getLaborScopeTotalParts,
    getSetupModeSpansShift,
    getNetShiftSetupParts,
    getTotalUserAddedManualPartCounts,
  ],
  (
    netSetupParts,
    rejectedParts,
    laborTicketPartsMade,
    setupModeSpansShift,
    netShiftSetupParts,
    totalUserAddedManualPartCounts
  ) => {
    const parts =
      (setupModeSpansShift ? netShiftSetupParts : netSetupParts) +
      totalUserAddedManualPartCounts;

    const displayParts = parts;

    return {
      displayParts,
      rejectedParts,
      unsubmittedParts: laborTicketPartsMade,
    };
  }
);

export { getSetupPartsDisplay };
